<template>
	<div class="submitWrapper paddBottom">
		<IndexHeaderOthers ref="indexHeader"></IndexHeaderOthers>
		<div class="main">
			<div class="conner">
				<div class="listData">
					<el-descriptions class="margin-top" :column="1" size="small" border>
						<el-descriptions-item v-for="(item, index) in ListData" :key="index">
							<template slot="label">
								{{ item.label }}
							</template>
							{{ CircularqueryById[item.name] }}
						</el-descriptions-item>
					</el-descriptions>
				</div>
				<pre class="desc">{{CircularqueryById.content}}</pre>
				<div class="desc2">
					SOURCE：{{CircularqueryById.detailUrl}}
				</div>
				<Message ref="message" :titles="titles" @getInfo="getInfos"></Message>
			</div>
		</div>
	</div>
</template>
<script>
import IndexHeaderOthers from "../../components/header/indexHeaderOthers.vue";
import Message from "../../components/page/Message";
import { format } from '../../utils/index.js'

export default {
	name: "circularsIndex",
	components: { IndexHeaderOthers, Message },
	data() {
		return {
			id: this.$route.query.id,
			ListData: [
				{
					label: "TITLE:",
					name: 'title',
				},
				{
					label: "NUMBER:",
					name: 'number',
				},
				{
					label: "SUBJECT: ",
					name: 'subject',
				},
				{
					label: "DATE:",
					name: 'circularTime',
				},
				{
					label: "FROM:",
					name: 'source',
				},
			],
			CircularqueryById: [],
			titles:'Circulars'
		};
	},
	methods: {
		//Circular详情列表
		getCircularqueryById() {
			const param = { id: this.id }
			this.$fetchGet('/cms-middle/astronCircular/queryById', param).then((res) => {
				this.CircularqueryById = res.astronCircular;
				this.CircularqueryById.circularTime = format(this.CircularqueryById.circularTime,
								'yyyy-MM-dd hh:mm:ss')
				this.NoticequeryById = res.astronNotice;
			});
		},
		format(date){
		   var date = new Date(date);
		   var Y = date.getFullYear() + '-';
		   var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
		   var D = date.getDate() + ' ';
		   var h = date.getHours() + ':';
		   var m = date.getMinutes() + ':';
		   var s = date.getSeconds(); 
		   var a = Y+M+D+h+m+s; 
		    return a; 
		},
		getInfos(e){
			this.id = e.id
			this.getCircularqueryById()
		}
	},
	created() {
	},
	mounted() {
		this.$refs.message.activeName = "Circulars";
		this.getCircularqueryById()
		// window.addEventListener("scroll", this.$refs.indexHeader.scrollToTop, true);
	},
};
</script>
<style scoped>
.main {
	position: relative;
	margin-top: -70px;
	z-index: 99;
	width: 100%;
	height: auto;
	background: #fff;
	border-radius: 0 120px 0 0;
}

.conner {
	width: 1050px;
	margin: 0 auto;
	text-align: left;
}

.listData {
	padding-top: 30px;
}

.desc {
	border-top: 2px solid #008dc9;
	margin-top: 22px;
	background: #f7f9fb;
	padding: 12px;
	padding-bottom: 0;
}

pre{
	margin-bottom: 0;
	word-wrap: break-word;
	white-space: pre-wrap;
}
.desc2 {
	/* height: 410px; */
	background: #f7f9fb;
	padding: 12px;
	font-size: 14px;
}
.desc p {
	margin: 25px 32px;
	font-size: 14px;
	font-family: Alibaba Sans;
	font-weight: 500;
	color: #333333;
	line-height: 23px;
}

.desc p:first-child {
	margin-top: 44px;
}
</style>
